const ast = {
  parameters: [
    {
      name: 'AST-female',
      displayName: 'AST',
      id: 'ast',
      validFrom: '2026/04/06 1:00',
      validThrough: null,
      interpretationsSupported: ['normal', 'too-high', 'fault'],
      criteria: {
        sexe: ['female'],
        age: {
          min: 5,
          max: 110,
        },
      },
      ranges: [
        {
          color: '#1f7359',
          description: 'AST-female-normal',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 35,
          upperLimitOperator: '<',
          unit: 'U/l',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
          rangeInterpretation: '0 - 34',
        },
        {
          color: '#f52d0a',
          description: 'AST-female-too-high',
          lowerLimit: 35,
          lowerLimitOperator: '>=',
          upperLimit: 500,
          upperLimitOperator: '',
          unit: 'U/l',
          interpretation: 'too-high',
          displayInterpretation: 'Too high',
          rangeInterpretation: '>= 35',
        },
      ],
    },
    {
      name: 'AST-male',
      displayName: 'AST',
      id: 'ast',
      validFrom: '2026/04/06 1:00',
      validThrough: null,
      interpretationsSupported: ['normal', 'too-high', 'fault'],
      criteria: {
        sexe: ['male'],
        age: {
          min: 5,
          max: 110,
        },
      },
      ranges: [
        {
          color: '#1f7359',
          description: 'AST-male-normal',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 50,
          upperLimitOperator: '<',
          unit: 'U/l',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
          rangeInterpretation: '0 - 49',
        },
        {
          color: '#f52d0a',
          description: 'AST-male-too-high',
          lowerLimit: 50,
          lowerLimitOperator: '>=',
          upperLimit: 500,
          upperLimitOperator: '',
          unit: 'U/l',
          interpretation: 'too-high',
          displayInterpretation: 'Too high',
          rangeInterpretation: '>= 50',
        },
      ],
    },
  ],
};

export default ast;
